export enum SafelyResource {
    PROPERTY,
    GUEST,
    RESERVATION,
    CLAIM
}